import { AOQualityPreset } from '@inter-ikea-betrakta/viewer';
const defaultAssetsPath = '/assets/';
const assetsPath = import.meta.env.REACT_APP_ASSETS_PATH || defaultAssetsPath;
// TODO: [STOR-3815] validate environment variables at build time instead
const sanitizePath = (path) => {
    const url = new URL(path, window.location.href);
    // Remove double slashes and trailing slashes
    url.pathname = url.pathname.replace(/\/{2,}/g, '/').replace(/\/+$/, '');
    return url.href;
};
export const FloorMaterials = {
    WOOD: sanitizePath(`${assetsPath}/generic/materials/room/floor/new_wooden_floor.glb`),
    CONCRETE: sanitizePath(`${assetsPath}/generic/materials/room/floor/floor_concrete.glb`)
};
export const defaultRenderSettings = {
    environmentMap: {
        url: sanitizePath(`${assetsPath}/generic/envmaps/210701_pax_env_lowres_lowsat_2.env`),
        intensity: 0.6,
        assemblyInstructionIntensity: 1.5,
        rotation: 80,
        localMode: {
            size: { x: 7.5, y: 5, z: 7.5 },
            position: { x: 0, y: 1, z: 0 }
        }
    },
    directionalLight: {
        enabled: true,
        position: { x: 1, y: 6, z: 3 },
        target: { x: 0, y: 0, z: 0 },
        intensity: 3,
        color: { r: 191, g: 191, b: 191 },
        enableShadows: true,
        shadowFar: 10,
        shadowNear: 1,
        shadowResolution: 4096
    },
    pointLight: {
        enabled: false,
        intensity: 6,
        enableShadows: true,
        position: { x: 0, y: 3, z: 2 },
        color: { r: 191, g: 191, b: 191 },
        shadowNear: 0.1,
        shadowFar: 40,
        shadowResolution: 4096
    },
    spotLight: {
        intensity: 8,
        color: { r: 255, g: 204, b: 168 },
        positionAdjustment: { y: -0.02, z: 0.3 }
    },
    lineLight: {
        intensity: 3,
        color: { r: 255, g: 204, b: 168 },
        angleRange: 120
    },
    ceilingLight: {
        color: { r: 255, g: 255, b: 255 },
        intensity: 2
    },
    floorLight: {
        color: { r: 255, g: 255, b: 255 },
        intensity: 3
    },
    mainLight: {
        position: { x: 0, y: 5, z: 2 },
        intensity: 130,
        outerAngleDegrees: 104,
        innerAngleDegrees: 60,
        shadow: {
            shadowNear: 1,
            shadowFar: 6,
            shadowResolution: 2048,
            enableShadows: true,
            bias: { z_units: 48000, z_factor: 3 }
        },
        colorTemperature: 6500
    },
    roomMaterials: [
        {
            id: 'WALL',
            url: sanitizePath(`${assetsPath}/generic/materials/room/wall/new_wall_1.glb`),
            previewUrl: ''
        },
        {
            id: 'SKIRTING',
            url: sanitizePath(`${assetsPath}/generic/materials/room/skirting/skirting.gltf`),
            previewUrl: ''
        },
        {
            id: 'FLOOR',
            url: sanitizePath(FloorMaterials.WOOD),
            previewUrl: ''
        },
        {
            id: 'THICKNESS',
            url: '',
            previewUrl: '',
            colorCode: '#FFFFFF'
        },
        {
            id: 'CEILING',
            url: '',
            previewUrl: '',
            colorCode: '#FFFFFF'
        }
    ],
    temporalEffects: {
        temporalAntiAliasing: false,
        screenSpaceAmbientOcclusion: false,
        ssaoParams: {
            enabled: true,
            radius: 0.05,
            ambientOccluionStrength: 0.8
        }
    },
    darkMode: {
        environmentMapIntensity: 0.4,
        glow: {
            enabled: true,
            blurSize: 15,
            intensity: 2.2
        },
        directionalLight: {
            intensity: 0.1
        },
        lineLight: {
            intensity: 0.1,
            angle: 45
        },
        spotLight: {
            intensity: 8,
            angle: 93,
            width: 8
        },
        temporalEffects: {
            temporalAntiAliasing: false,
            screenSpaceAmbientOcclusion: false,
            ssaoParams: {
                enabled: true,
                radius: 0.3,
                ambientOccluionStrength: 0.8
            },
            quality: AOQualityPreset.DESKTOP_DEFAULT
        }
    }
};
//# sourceMappingURL=defaultRenderSettings.js.map